export const adminUrls = {
    dashboard: {
        general: '/admin/dashboard',
        viewsChart: '/admin/dashboard/view-chart',
        financialChart: '/admin/dashboard/financial-chart',
        customerInvoicesChart: '/admin/dashboard/customer-invoices-chart',
        coworkerInvoicesChart: '/admin/dashboard/coworker-invoices-chart',
    },
    customerClub: {
        clubs: (id) => id ? `/admin/customer-club/campaigns/${id}` : "/admin/customer-club/campaigns",
        rating: (id) => id ? `/admin/customer-club/levels/${id}` : "/admin/customer-club/levels",
        event: (id) => id ? "" : "",
    },
    articles: {
        pageController: '/admin/general/page/articles',
        list: '/admin/articles',
        item: (articleSlug) => `/admin/articles/${articleSlug}`,
        categories: (categoryId) => categoryId ? `/admin/articles/categories/${categoryId}` : '/admin/articles/categories'
    },
    services: {
        pageController: '/admin/general/page/services',
        list: '/admin/services',
        item: (serviceSlug) => `/admin/services/${serviceSlug}`,
        categories: (categoryId) => categoryId ? `/admin/services/categories/${categoryId}` : '/admin/services/categories'
    },
    catalog: {
        pageController: '/admin/general/page/catalogs',
        list: '/admin/catalogs',
        item: (catalogSlug) => `/admin/catalogs/${catalogSlug}`,
        categories: (categoryId) => categoryId ? `/admin/catalogs/categories/${categoryId}` : '/admin/catalogs/categories'
    },
    products: {
        pageController: '/admin/general/page/products',
        features: (featureId) => featureId ? `/admin/features/${featureId}` : '/admin/features',
        featuresOptions: (featureId) => featureId ? `/admin/features/options/${featureId}` : '/admin/features/options',
        categories: (categoryId) => categoryId ? `/admin/products/categories/${categoryId}` : '/admin/products/categories',
        parentFeatures: (parentId) => `/admin/products/categories/${parentId}/features`,
        attribute: (attributeId) => attributeId ? `/admin/product-attributes?product_id=${attributeId}` : '/admin/product-attributes',
        list: '/admin/products',
        item: (productId) => `/admin/products/${productId}`,
        increaseQtyForAll: '/admin/products/change/qty',
        universalOffer: '/admin/products/universal-offer' ,
    },
    attribute: {
        pageController: '/admin/general/page/attributes',
        group: (attributeId) => attributeId ? `/admin/attributes/${attributeId}` : '/admin/attributes',
    },
    productFeatureGroups: {
        pageController: '/admin/general/page/productFeatures',
        list: '/admin/products/feature-groups',
        item: (featureGroupId) => `/admin/products/feature-groups/${featureGroupId}`,
    },
    icons: '/admin/icons',
    wallet: {
        deposit:(id)=> id ? `/admin/wallet/deposit?user_id=${id}` : "/admin/wallet/deposit",
        withdraw:(id)=> id ? `/admin/wallet/withdraw?user_id=${id}` : "/admin/wallet/withdraw",
    },
    webSettings: '/admin/generals',
    CvInformation: '/admin/cv-information',
    sliders: {
        list: '/admin/sliders',
        item: (sliderId) => `/admin/sliders/${sliderId}`,
    },
    catalogues: {
        list: '/admin/catalogues',
        images: '/admin/catalogues-images',
        item: (catalogueId) => `/admin/catalogues-images/${catalogueId}`,
    },
    gallery: {
        list: '/admin/galleries',
        item: (imageId) => `/admin/galleries/${imageId}`,
        categories: "/admin/general/page/galleries"
    },
    banners: {
        list: '/admin/banners',
        item: (bannerId) => `/admin/banners/${bannerId}`,
    },
    productCategoryBanners: {
        pageController: '/admin/general/page/productCategoryBanners',
        list: '/admin/product-category-banners',
        item: (bannerId) => `/admin/product-category-banners/${bannerId}`,
    },
    faq: (questionId) => questionId ? `/admin/faq/${questionId}` : '/admin/faq',
    guide: (questionId) => questionId ? `/admin/guides/${questionId}` : '/admin/guides',
    menu: {
        pageController: '/admin/general/page/menu',
        get: '/admin/menu/get',
        set: '/admin/menu/set',
    },
    media: {
        list: '/admin/media',
        item: (mediumId) => `/admin/media/${mediumId}`,
    },
    roles: {
        list: '/admin/role-permission',
        item: (rolesId) => `/admin/role-permission/${rolesId}`,
        references: (rolesId) => `/admin/role-permission/references/${rolesId}`,
        categories: (rolesId) => `/admin/role-permission/category/${rolesId}`,
    },
    users: {
        customers: {
            list: (id) => id ? `/admin/users/customers/${id}` : `/admin/users/customers`,
            item: (id) => `/admin/users/customers/${id}`,
            suspend: (id) => `/admin/users/customers/suspend/${id}`,
            coWorker: (id) => `/admin/users/customers/co-worker/${id}`,
            permissions: (id) => id ? `/admin/users/customers/permissions/${id}` : `/admin/users/customers/permissions`,
        },
        coWorker: {
            list: (id) => id ? `/admin/users/co-worker/${id}` : `/admin/users/co-worker`,
            editAll: `/admin/users/co-worker/offers`,
        },
        personnel: {
            list: (id) => id ? `/admin/users/staff/${id}` : `/admin/users/staff`,
            roleList: '/admin/role-permission?list=select'
        }
    },
    comments: {
        list: `/admin/comments`,
        //for approve , reject or delete
        item: (id) => `/admin/comments/${id}`,
    },
    deliveryMethods: {
        list: "/admin/delivery",
        item: (id) => id ? `/admin/delivery/${id}` : `/admin/delivery`,
    },
    smsSetting: {
        admin: (id) => id ? `/admin/admin-sms/${id}` : `/admin/admin-sms`,
        customer: (id) => id ? `/admin/customer-sms/${id}` : `/admin/customer-sms`
    },
    customers: {
        addressList: (id) => id ? `/customer/address/${id}` : `/customer/address`,
        invoices: (id) => id ? `/customer/invoices/${id}` : `/customer/invoices`,
        invoicesPay: (id) => `/customer/invoices/${id}/pay`,
        comments: (id) => id ? `/customer/comments/${id}` : `/customer/comments`,
        favorite: (id) => id ? `/customer/favorite/${id}` : `/customer/favorite`,
    },
    coupons: {
        list: "/admin/coupons",
        page: "/admin/general/page/coupon",
        item: (id) => id ? `/admin/coupons/${id}` : `/admin/coupons`,
    },
    orders: {
        list: "/admin/orders",
        orderStatus: (id) => id && `/admin/orders/${id}/change-status`,
        item: (id) => id ? `/admin/orders/${id}` : "/admin/orders",
        orderItemQty: (orderId, orderItemId) => `/admin/orders/qty/${orderId}/${orderItemId}`,
        orderItemFinancialCode: (orderItemId) => `/admin/orders/financial/code/${orderItemId}`,
        referenceList: "/admin/general/page/orderReferences",
        userAddressList: `/admin/general/page/orderAddress`,
        deliveryList: "/admin/general/page/orderDelivery",
        changeAddress: (orderId) => `/admin/orders/address/${orderId}`,
        changeDelivery: (orderId) => `/admin/orders/delivery/${orderId}`,
        reference: (orderId) => `/admin/orders/reference/${orderId}`,
        page: `/admin/general/page/order`, //orderId must be sent for this endpoint
        listOrderStatus: `/admin/general/page/orderStatus`, //orderId must be sent for this endpoint
        label: (id) => `/admin/orders/label/${id}`,
        editAdviceProducts: '/admin/orders/advice'
    },
    invoices: {
        pageController: '/admin/general/page/invoices',
        list: (orderId) => orderId ? `/admin/invoices/${orderId}` : "/admin/invoices",
        pay: (orderId) => `/admin/invoices/pay/${orderId}`,
        show: (orderId, invoiceId) => `/admin/invoices/${orderId}/${invoiceId}`, //for show and update
        print: (invoiceId) => `/admin/invoice/print/${invoiceId}`
    },
    production: {
        pageController: '/admin/general/page/produce',
        list: "/admin/produce",
        item: id => id ? `/admin/produce/${id}` : "/admin/produce",
        page: `/admin/general/page/references`,
        warehouse: `/admin/produce/warehouse`,
        weeklyLog: reference => `/admin/produce/weeklyLog/${reference}`,
        weeklyLogTasks: reference => `/admin/produce/weeklyLog/tasks/${reference}`,
        reference: `/admin/reference/status`
    },
    discharge: {
        list: "/admin/discharge",
        item: id => id ? `/admin/discharge/${id}` : "/admin/discharge",
        page: `/admin/general/page/discharge`,
        return: `/admin/discharge/production`,
        warehouse: id => `/admin/discharge/warehouse/${id}`,
        postStatus: id => `/admin/discharge/status/${id}`,
    },
    productionPersonnel: {
        list: "/admin/produce/personnel",
    },
    logs: {
        list: "/admin/logs"
    },
    excel: {
        fields: "/admin/export/fields",
        generate: "/admin/export/generate"
    },
    stories: {
        template: (templateID) => templateID ? `/admin/stories/${templateID}` : "/admin/stories",
        status: (id) => `/admin/stories/${id}/change-home-display`,
        view: (id) => `/general/stories/${id}`
    },
    contact: '/admin/contact',
    ReservationRequest: (id)=> id ? `/admin/reservation-requests/${id}` :  '/admin/reservation-requests',
    seo: {
        redirects: {
            list: "/admin/seo/rules",
            item: id => id ? `/admin/seo/rules/${id}` : "/admin/seo/rules",
        }, pages: {
            list: "/admin/seo/pages",
            item: id => id ? `/admin/seo/pages/${id}` : "/admin/seo/pages",
        }
    },
    groupOffer: {
        group: (id, isDelete) => id ? isDelete ? `/admin/products/group-offers/${id}` : `/admin/products/group-offers/${id}/items` : '/admin/products/group-offers'
    },
    referral: {
        referralCode: (id) => `/admin/affiliate-program/assign-referral-code/${id}`,
        generate: `/admin/affiliate-program/generate-referral-code`,
    },
    customerBrand: (id) => id ? `/admin/customers/${id}` : '/admin/customers',
    brand: (id) => id ? `/admin/brands/${id}` : '/admin/brands',
    tags: (id) => id ? `/admin/tags/${id}` : '/admin/tags',
    transaction: "/admin/transactions",
    commercialPartners: (id) => id ? `/admin/commercial-partners/${id}` : '/admin/commercial-partners',
    fields: {
        list: (id) => id ? `/admin/fields/${id}` : '/admin/fields',
        options: (id) => id ? `/admin/fields/options/${id}` : '/admin/fields/options',
        formulas: (id) => id ? `/admin/formulas/${id}` : '/admin/formulas'
    },
    variables: {
        list: '/admin/variables',
        item: (id) => id ? `/admin/variables/${id}` : '/admin/variables',
    },
    options: "/admin/fields/options",
    servicesCategory: {
        list: (id) => id ? `/admin/services/categories/${id}` : "/admin/services/categories"
    },
    catalogCategory:{
        list:(id) => id ? `/admin/catalogs/categories/${id}` : "/admin/catalogs/categories"
    },
    warehouse: (warehouseID) => warehouseID ? `/admin/warehouse/${warehouseID}` : "/admin/warehouse",
}
